"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const constants_1 = require("../utils/constants");
function provide(serviceIdentifier) {
    return (target, targetKey, indexOrPropertyDescriptor) => {
        (0, inversify_1.inject)(serviceIdentifier)(target, targetKey, indexOrPropertyDescriptor);
        (0, inversify_1.tagged)(constants_1.PROVIDED_TAG, true)(target, targetKey, indexOrPropertyDescriptor);
    };
}
exports.default = provide;
